import { render, staticRenderFns } from "./FailModal.vue?vue&type=template&id=cb4c7920&"
import script from "./FailModal.vue?vue&type=script&lang=js&"
export * from "./FailModal.vue?vue&type=script&lang=js&"
import style0 from "./FailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports